import { defineMessages } from "react-intl";

const PREFIX = "BulkExportPage.Subscription.Validation";
export default defineMessages({
  emptySelection: {
    id: `${PREFIX}.emptySelection`,
    defaultMessage: "All dimensions must be filled",
  },
});
